import { render, staticRenderFns } from "./HelpRequest.vue?vue&type=template&id=79e90ccc&scoped=true&"
import script from "./HelpRequest.vue?vue&type=script&lang=js&"
export * from "./HelpRequest.vue?vue&type=script&lang=js&"
import style0 from "./HelpRequest.vue?vue&type=style&index=0&id=79e90ccc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e90ccc",
  null
  
)

export default component.exports